hrd.AbstractDashboard = hrd.Class.extend({
	multipleLayouts: false,
	activeLayout: undefined,
	storage: {},
	device: 'desktop',
	PC_Q: 'only screen and (min-width: 1201px)',
	IPAD_MQ: 'only screen and (min-device-width : 768px) and (max-device-width : 1024px)',
	IPAD_L_MQ: 'only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape)',
	IPAD_P_MQ: 'only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait)',

	init: function(options) {
		var defaults = {
			impl: 'hrd.AbstractDashboard',
			resizeDelay: 2000,
			splashScreenStartDuration: 1000,
			splashScreenEndDuration: 3000,
			resizeAfterSplashScreen: true,
			uuid: parseInt(Math.random() * 100000),
			intercom: {
				skipLocalEmit: []
			},
			permissions: {
				canWriteTBP: 'global:Global:canWriteTenantBusinessProperties'
			},
			images: {

			}
		};
		this._super($.extend(true, {}, defaults, options));

		this.intercom = Intercom.getInstance(this.settings.intercom);
		this.presentationManager = new hrd.PresentationManager();
		this.toolbox = new hrd.Toolbox();
		if (this.settings.xlate) {
			var bundle = this.settings.xlate.bundle || undefined;
			var bundles = this.settings.xlate.bundles || undefined;
			var prefixes = this.settings.xlate.prefixes || [];
			var xlatePromise = hrd.xlate.load(bundle, prefixes, bundles);
			var permissionPromise = this.evaluatePermissions(this.settings.permissions);
			var snippetsPromise = this.downloadSnippets(this.settings.snippets);
			$.when(xlatePromise, permissionPromise, snippetsPromise).then((xlateData, permissionData, snippetData) => {
				if (snippetData) {
					const toHtmlContainerId = (key) => $.functionCase(`${key}-snippet-container`);
					const toHtmlContainer = (key) => $(`<div id="${toHtmlContainerId(key)}" class="ui-helper-hidden"></div>`);

					this.snippetData = snippetData;
					// apply 'inline' snippets
					Object.entries(snippetData).forEach(snippetDef => {
						let snippetInfo = snippetDef[1];
						if (snippetInfo.type === 'inline') {
							let key = snippetDef[0];
							let $container = toHtmlContainer(key);
							$container.append(snippetInfo.snippet);
							$('body').append($container);
						}
					});
				}
				this.applyPresentationConfig()
					.then(() => this.doPreInit())
					.then(() => this.doSplashScreen())
					.then(() => this.doPostInit())
					.then(() => this.doDashboard());
			});
		} else {
			dashboardReady.reject();
			/* this message cannot be translated because xlate is missing */
			hrd.dashboard.msgBox({
				title: 'Configuration Error',
				text: 'Localization not propertly set. <p>Please configure this dashboard accordingly',
				okLabel: 'Ok',
				type: 'OK'
			});
		}

		this.intercom.on('is-dashboard-loaded', function(dashboard) {
			if (dashboard == this.currentDashboard) {
				this.intercom.emit('dashboard-is-loaded', dashboard);
			}
		}.bind(this));

		// store in window the current dashboard instance: this can be done beacuse only one 'dashboard' per page can be available...
		/**
		 * @type hrd.AbstractDashboard
		 * */
		window['dashboardInstance'] = this;
		// inject font-awesome
		var faNumberTemplate = '.fa-custom-{n}:before {content: "{n}";}\n';
		var rules = '';
		for (var n = 0; n < 100; n++) {
			rules += hrd.utils.replaceParams(faNumberTemplate, { n: n });
		}
		this.injectStyles(rules);


		$.timeout(0)
			.then(() => {
				if(this.usingChromaFlow()) {
					this.injectFieldsSetStyles(2);
					this.injectFieldsSetStyles(3);
					this.injectFieldsSetStyles(4);
					this.injectFieldsSetStyles(5);
					this.injectFieldsSetStyles(7);
					this.injectFieldsSetStyles(8);
					this.injectFieldsSetStyles(10);
					this.injectFieldsSetStyles(20);
				}
			});

		var bodyOptions = $.evaluate($('body').data('options')) || {};
		if (bodyOptions.doubleSize) {
			this.applyDoubleSize();
		}
	},
	usingChromaFlow: function() {
		const toolbox = new hrd.Toolbox();
		const useSideBarMenu = toolbox.get('globals.prefs.tenant.layout.useSideBarMenu', hrd);
		return useSideBarMenu;
	},
	injectStyles(rule) {
		$("<div />", {
			html: '&shy;<style>' + rule + '</style>'
		})
			.addClass('ui-helper-hidden-important')
			.appendTo("body");
	},
	/**
	 * Utility to add fieldset-<blocks> styles, included the -<n>-<blocks> rules
	 * where n is between 1 and <blocks>. Eventually is possible to define which of the secondary rules must be added using the values array
	 *
	 * for example injectFieldsSetStyles(32, [5, 10, 12]) will generate only 'fieldset-5-32', 'fieldset-10-32' and 'fieldset-12-32' rules
	 */
	injectFieldsSetStyles(blocks, values) {
		values = values || [...Array(blocks + 1).keys()].slice(1);
		let rules = '';
		
		if(this.usingChromaFlow()) {
			rules = `
				.dashlet-fieldset div.fieldset-${blocks} {
					display: flex;
					flex-direction: row;
					gap: 0.5rem;
					justify-content: space-between;
					min-width: 0;
				}
			`;
			
			for (var n = 1; n <= blocks; n++) {
				let width = n * (100 / blocks);
				if (values.includes(n)) {
					rules += `
						.dashlet-fieldset div.fieldset-${n}-${blocks} {
							box-sizing: border-box;
							flex: ${n};
							width: ${width.toFixed(3)}%;
							min-width: 0;
							display: flex;
							flex-direction: column;
							gap: 0.5rem;
						}
					`;
				}
			}
		} else {
			rules = `
				.dashlet-fieldset div.fieldset-${blocks} {
					display: flex;
					justify-content: space-between;
				}
			`;
			
			for (var n = 1; n <= blocks; n++) {
				let width = n * (100 / blocks);
				if (values.includes(n)) {
					rules += `
						.dashlet-fieldset div.fieldset-${n}-${blocks} {
							box-sizing: border-box;
							flex: ${n} 0 auto;
							width: ${width.toFixed(3)}%;
						}
					`;
				}
			}
		}
		
		this.injectStyles(rules);
	},
	loadCSSFile(filename, family) {
		var fileref = document.createElement("link");
		if (family) {
			fileref.setAttribute("id", 'dynamic-font-family');
			fileref.setAttribute("data-family", family);
		}
		fileref.setAttribute("rel", "stylesheet")
		fileref.setAttribute("type", "text/css")
		fileref.setAttribute("href", filename)
		document.getElementsByTagName("head")[0].appendChild(fileref);
	},
	isDashboardLoaded: function(dashboard) {
		var deferred = $.Deferred();
		this.intercom.emit('is-dashboard-loaded', dashboard);

		var remoteDeferred = $.Deferred();
		this.intercom.on('dashboard-is-loaded', function(dashboardLoaded) {
			if (dashboard == dashboardLoaded) {
				remoteDeferred.resolve();
			}
		}.bind(this));

		$.when.raceAgainstTime(remoteDeferred.promise(), 1000)
			.then(() => deferred.resolve())
			.fail(() => deferred.reject());
		return deferred.promise();
	},
	doPreInit: function() {
		return $.when(); // a resolved promise
	},
	doPostInit: function() {
		return $.when(); // a resolved promise
	},
	initComplete: function() {
		if (this.dashlets) {
			$.each(this.dashlets, function(i, dashlet) {
				dashlet.dashboardHasCompleted();
			});
		}

		if (hrd.dashlets.topArea !== undefined) {
			hrd.dashlets.topArea.dashboardHasCompleted();
		}

		const configAsync = this.doTourConfig ? $.when(this.doTourConfig()) : $.when([]);
		let tourId = this.getTourId();

		configAsync
			.then((config) => {
				this.tourConfig = config;

				try {
					if (hrd.utils.inIFrame() && window.top.dashboardConfig) {
						this.tour = new hrd.Tour(tourId, this.tourConfig);

						Intercom.getInstance().on(`start-${tourId}`, (options = {}) => {
							this.tour.start(!!options.forceStart);
						});
					} else {
						this.tour = new hrd.Tour(tourId, this.tourConfig);
					}
				} catch (error) {
					this.tour = new hrd.Tour(tourId, this.tourConfig);
				}

				$.emit('tour-config-loaded', {
					tour: this.tour,
					config: this.tourConfig
				});
			});

		this.doInitCompleted();
	},
	doDashboard: function() {
		dashboardReady.resolve();
		this.registerResize();
		this.doLocalizations();
		//this.applyPresentationConfig();
		this.doLayout();
		this.doTabs();
		this.doPanels();
		
		// chroma flow need an initial resize for rendering complex tabs correctly
		let redraw = this.usingChromaFlow() ? true : false;
		this.resize(redraw); 

		this.loadDashlets();
		// post-resize of panels and tabs before loading dashlets
		this.resizeOnlyPanels();

		this.registerEvents();
		this.postLoad();
	},
	doSplashScreen: function(message, options = {}) {
		const { closeWhen } = options;
		this.splashScreenOptions = options;

		/* if viewport.height is less than 720, a vertical scrollbar will appear. so that a force resize must be triggered */
		var resize = this.settings.resizeAfterSplashScreen || ($.pgwBrowser().viewport.height < 720 && !(this.settings.blockResizeAfterSplashScreen == true));
		var logo = null;

		if (this.getSplashScreenLogo()) {
			logo = {
				type: "IMAGE",
				url: this.getSplashScreenLogo()
			};
		} else if (!this.getSplashScreenLogo() && this.getSplashScreenIcon()) {
			logo = {
				type: "ICON",
				info: this.getSplashScreenIcon()
			};
		}

		if (!closeWhen || (closeWhen && closeWhen.state() === 'pending')) {
			hrd.dashboard.showLoadingSplashScreen(message, {
				startDuration: this.settings.splashScreenStartDuration,
				endDuration: this.settings.splashScreenEndDuration,
				resize: resize,
				closeWhen
			});
			this.doTopArea(message);

			if (logo) {
				switch (logo.type) {
					case "IMAGE":
						if (logo.url !== "") {
							$('#loader .spinner-container .header').prepend(`
							<img class="logo" src="${logo.url}" alt="" />
						`);

							$('#loader .spinner-container .header .logo').on('error', function() {
								console.log('The image doesn\'t exist.');

								$(this).detach();
							});
						}
						break;
					case "ICON":
						if (logo.info.icon && logo.info.icon !== "") {
							$('#loader .spinner-container .header').prepend(`
							<i class="f-icon ${logo.info.icon}"></i>
						`);

							if (logo.info.color && logo.info.color !== "") {
								$('#loader .spinner-container .header i').css({
									"color": logo.info.color
								});
							}
						}
						break;
				}
			}
		} else {
			hrd.dashboard.closeSplashScreen({
				startDuration: 0,
				endDuration: 0,
				resize: resize,
			});
		}
	},
	getSplashScreenLogo: $.noop,
	getSplashScreenIcon: $.noop,
	getImagePath: function(imageName) {
		const image = this.settings.images[imageName];
		let path = '';

		if (image) {
			path = `${hrd.globals.contextRoot}/media/js/dashboard/${image}`;
		} else {
			console.log('Image "' + imageName + '" not defined in dashboard.');
		}

		return path;
	},
	doTopArea: function(message) {
		// only if toparea is available
		if (hrd.dashlets.topArea) {
			hrd.dashlets.topArea.ready(message);
		}
	},
	doLocalizations: function() {
		var language = hrd.xlate.language;
		if ($.datepicker) {
			$.datepicker.setDefaults($.datepicker.regional[language]);
		}
		if ($.timepicker) {
			$.timepicker.setDefaults($.timepicker.regional[language]);
		}
		window['localeNumberConverter'] = new hrd.utils.NumberConverter({ locale: hrd.xlate.locale, localeSpecs: hrd.xlate.localeSpecs });
	},
	applyPresentationConfig: function() {
		return this.presentationManager.execute();
	},
	applyFont: function(fontInfo) {
		return this.presentationManager.applyFont(fontInfo);
	},
	doLayout: $.noop,
	doTabs: function() {
		this.doAutoTabs();
	},
	doPanels: $.noop,
	doInitCompleted: $.noop,
	doTourConfig: () => [],
	getTourId: function() {
		const toolbox = new hrd.Toolbox();
		const tenantId = toolbox.get('globals.prefs.tenant.systenant', hrd, '');
		const nodeId = toolbox.get('globals.prefs.node.currentNode', hrd, '');
		const userId = toolbox.get('globals.prefs.user.userId', hrd, '');
		let dashboardInstance = this;

		try {
			dashboardInstance = (hrd.utils.inIFrame() && window.top.dashboardConfig) ? window.top.dashboardConfig.getDashboardInstance() : this;
			if (dashboardInstance == undefined) {
				dashboardInstance = this;
			}
		} catch (error) {
			dashboardInstance = this;
		}

		return `T${tenantId}_N${nodeId}_U${userId}-${dashboardInstance._NAME_}-tour`;
	},
	registerResize: function() {
		var resizeTimeout = undefined;
		$(window).on('resize.dashboard', function(event) {
			var noResizing = $(event.target).hasClass('ui-dialog') || $(event.target).hasClass('fc-event');
			if (!noResizing) {
				var br = $.pgwBrowser();
				$('body').attr('data-viewport', br.viewport.width + 'x' + br.viewport.height + "_" + br.viewport.orientation.substring(0, 1).toUpperCase());
				clearTimeout(resizeTimeout);
				/* set the convenience variable to true, so that layout-resize will skip its execution*/
				this._ignoreLayoutResize = true;
				resizeTimeout = setTimeout(this.resize.bind(this), this.settings.resizeDelay, true);
			}
		}.bind(this));
	},
	getResponsiveBreakpoints: function() {
		return {
			desktop: { min: 1200, isDefault: true },
			tablet: { max: 1200 },
			mobile: { max: 576 }
		};
	},
	getActiveDevice: function() {
		const breakpointsData = this.getResponsiveBreakpoints();
		let activeDevice = Object.keys(breakpointsData).find(device =>
			breakpointsData[device].isDefault === true
		);

		Object.keys(breakpointsData).forEach(device => {
			const breakpointData = breakpointsData[device];

			const mediaQueryString = Object.keys(breakpointData)
				.map((key) => `(${key}-width: ${breakpointData[key]}px)`)
				.join(' and ');

			const isActiveDevice = window.matchMedia(mediaQueryString).matches;

			if (isActiveDevice) {
				activeDevice = device;
			}
		});

		return activeDevice;
	},
	renderChildrenOf: function(what, where, beforeRender = () => { }) {
		const $what = $(what);
		const $where = $(where);

		beforeRender(what, where);

		$where.html($what.children().detach());
	},
	renderResponsiveDashlets: function(currentDevice, targetDevice) {
		function beforeRender(what) {
			const $what = $(what);

			$what.find(`*[data-dashboard]`).each(function() {
				const $container = $(this);
				const data = $.evaluate($container.data('dashboard'));

				if (!Object.keys(data).includes('dashlet')) return;

				const $dashletTemplate = $(`#templates-container > *[data-dashlet-template="${data.dashlet}"]`);

				$container.html($dashletTemplate.children().detach());
			});
		}

		if (currentDevice === targetDevice) {
			const $targetLayout = this.$responsiveLayoutsContainer.find(`*[data-responsive="${targetDevice}"]`);

			this.renderChildrenOf($targetLayout, '#responsive-layout-position', beforeRender);
		}
		/*
		else {
			const $layoutPosition = $('#responsive-layout-position');
			const $currentLayout = this.$responsiveLayoutsContainer.find(`*[data-responsive="${currentDevice}"]`);
			const $targetLayout = this.$responsiveLayoutsContainer.find(`*[data-responsive="${targetDevice}"]`);

			$layoutPosition.find(`*[data-dashboard]`).each((index, container) => {
				const $container = $(container);
				const containerData = $.evaluate($container.data('dashboard'));

				if (!Object.keys(containerData).includes('dashlet')) return;

				$(`*[data-dashlet-template="${containerData.dashlet}"]`).html($container.children().detach());
			});

			$currentLayout.html($layoutPosition.children().detach());

			this.renderChildrenOf($targetLayout, $layoutPosition, beforeRender);

			this.doAutoLayout('#layout', {
				redrawLayout: true
			});
		}
		*/
	},
	renderResponsiveDashletsIf: function(condition) {
		const currentDevice = this.device;
		const targetDevice = this.getActiveDevice();
		const conditionToContinue = typeof condition === 'function'
			? condition(currentDevice, targetDevice)
			: !!condition;

		if (!conditionToContinue) return;

		this.device = targetDevice;

		this.renderResponsiveDashlets(currentDevice, targetDevice);
	},
	changeLayoutAndReload: function(layoutId) {
		this.storage.write(layoutId);
		document.location.reload();
	},
	resetLayoutAndReload: function() {
		this.storage.clear();
		document.location.reload();
	},
	doMultipleLayouts: function() {
		const $layouts = $('[data-custom-layout]');
		this.multipleLayouts = $layouts.exists() && $layouts.length > 1;
		this.device = this.getActiveDevice();
		const moveTemplates = (what) => {
			const $activeLayout = $(what);

			$('[data-dashboard]', $activeLayout).each((index, container) => {
				const $container = $(container);
				const containerData = $.evaluate($container.data('dashboard'));

				if (!Object.keys(containerData).includes('template')) return;

				const $template = $(`*[data-dashlet-template="${containerData.template}"]`);

				this.renderChildrenOf($template, $container);
			});
		};

		if (this.multipleLayouts) {
			const dashboardId = `${this._FULL_}${this._NAME_}`;
			this.storage = new hrd.config.LocalStorage({ prefix: dashboardId });
			const layoutId = this.storage.read();

			if (layoutId) {
				const $activeLayout = $layouts.filter((_, layout) => {
					const $layout = $(layout);
					const layoutData = $.evaluate($layout.data('custom-layout'));

					return layoutData.name === layoutId;
				});

				this.activeLayout = $.evaluate($activeLayout.data('custom-layout')).name;
				this.renderChildrenOf($activeLayout, $('#layout-position'), moveTemplates);
				$activeLayout.html(`<div data-dashboard="{ type: 'area', pane: 'center' }"></div>`);
			} else {
				let $defaultLayout = $('[data-layout-default]');

				if (!$defaultLayout.exists()) {
					$defaultLayout = $layouts.filter((_, layout) => {
						const $layout = $(layout);
						const layoutData = $.evaluate($layout.data('custom-layout'));

						return layoutData.device === this.device;
					});

					if (!$defaultLayout.exists()) {
						$defaultLayout = $layouts.first();
						const defaultLayoutData = $.evaluate($defaultLayout.data('custom-layout'));

						this.device = defaultLayoutData.device;
					}
				}

				this.activeLayout = $.evaluate($defaultLayout.data('custom-layout')).name
				this.renderChildrenOf($defaultLayout, $('#layout-position'), moveTemplates);
				$defaultLayout.html(`<div data-dashboard="{ type: 'area', pane: 'center' }"></div>`);
			}
		} else if ($layouts.length === 1) {
			console.log($layouts);

			const $defaultLayout = $layouts.first();
			const defaultLayoutData = $.evaluate($defaultLayout.data('custom-layout'));

			this.device = defaultLayoutData.device;

			this.renderChildrenOf($defaultLayout, $('#layout-position'), moveTemplates);
		}
		// /multiple layouts preparations

		// responsive layout preparations
		/*
		if(!$layout.exists()) {
			$('.body').prepend(`
				<div id="${mainElement.replace('#', '')}" data-dashboard="{ type: 'container' }">
				</div>
			`);

			$layout = $(mainElement);
		}

		this.$responsiveLayoutsContainer = $('#responsive-layout-container');

		if(this.$responsiveLayoutsContainer.exists()) {
			this.device = this.getActiveDevice();

			this.renderResponsiveDashletsIf(true);
		}*/
		// /responsive layout preparations
	},
	doAutoLayout: function(mainElement, options) {
		let hasWideSkin = $('body').hasClass('wide-skin');
		this.automatic = true;
		options = options || {};
		var $layout = $(mainElement);
		this.$mainLayout = $layout;
		const $customLayouts = $('[data-custom-layout]');
		var commonOptions = hrd.dashboard.layout.options;

		if (hasWideSkin) {
			commonOptions = $.extend(commonOptions, {
				spacing_open: 0,
				spacing_closed: 0,
			});
		}

		$customLayouts.width($layout.width());
		$customLayouts.height($layout.height());

		// <multiple layouts preparations>
		this.doMultipleLayouts();
		// </multiple layouts preparations>

		$('*[data-dashboard]:visible').each(function(i, dashlet) {
			var $dashlet = $(dashlet);

			$dashlet.uniqueId();
			var info = $.evaluate($dashlet.data('dashboard'), this);
			if (info) {
				let visible = info.size !== -1;
				if (!visible) {
					$dashlet.hide();
				} else {
					$dashlet.data('dashboardInfo', info);
					switch (info.type) {
						case 'container':
							$dashlet.addClass('dashlet-container layout-container');
							break;
						case 'area':
							$dashlet.addClass('dashlet-area');
							break;
						case 'tab':
							$dashlet.addClass('dashlet-tab dashlet-outer-tab layout-tab');
							break;
						default:
							break;
					}
					if (info.pane != undefined) {
						$dashlet.addClass('layout-pane');
					}
				}
			}
		}.bind(this));

		// tabs preparations
		$('.layout-tab').each(function(i, tab) {
			var $tab = $(tab);
			var info = $tab.data('dashboardInfo');
			if (info != undefined) {
				$tab.children('ul').addClass('dashlet-tabs');
				if (info.layout == 'simple') {
					$tab.addClass('simple-tab');
					$tab.children('div:not(".dashlet-tab-controls")').addClass('dashlet-tab-panes dashlet-tab-simple-layout ui-layout-content ui-widget-content');
				} else {
					$tab.addClass('complex-tab');
					$tab.children('div:not(".dashlet-tab-controls")').addClass('dashlet-tab-panes dashlet-tab-layout ui-layout-content ui-widget-content ui-corner-bottom ui-corner-tr');
				}
				$tab.children('div').children('div').addClass('dashlet-tab-pane full-height');
			}
		}.bind(this));

		/* need to fix tabs height before layout, otherwise is too late */
		$('.dashlet-tab').each(function(i, tab) {
			var $tab = $(tab);
			const { isStepper } = $tab.data('dashboardInfo') || {};

			var $tabLinks = $tab.children('ul');
			var tabLinksHeight = $tabLinks.outerHeight(true) == 0 ? '25' : $tabLinks.outerHeight(true); // 25px is needed because of nested tabs used inside a tab initially invisible

			if (isStepper) {
				tabLinksHeight = '99';
			}

			$tab.children('div.dashlet-tab-panes').css({
				height: 'calc( 100% - ' + tabLinksHeight + 'px )',
				width: '100%'
			});
			$tab.children('div.dashlet-tab-panes').children('div').addClass('full-height');
		});

		// apply layout to all visible containers
		$('.layout-container:visible').each(function(i, container) {
			var $container = $(container);
			var containerInfo = $container.data('dashboardInfo');
			var opts = {};
			$container.children('.layout-pane').each(function(j, pane) {
				var $pane = $(pane);
				var paneInfo = $pane.data('dashboardInfo');
				
				var paneType = paneInfo.pane;
				opts[`${paneType}__paneSelector`] = `#${$pane.attr('id')}`;
				if (paneInfo.sizeFn != undefined) {
					if(typeof this[paneInfo.sizeFn] === 'function') {
						let nSize = this[paneInfo.sizeFn].call(this, paneType, $pane);
						nSize = this.convertSize(nSize, hasWideSkin);
						opts[`${paneType}__size`] = nSize;
					} else {
						console.error(`A "layout-pane-size" function is declared but not available. Please add "${paneInfo.sizeFn}: function(paneType, $pane) {}," to "${this._FULL_}"`);
					}
				} else if (paneInfo.size !== undefined) {
					let nSize = this.convertSize(paneInfo.size, hasWideSkin);
					opts[`${paneType}__size`] = nSize;
				}
				
				if (paneInfo.customSlider != undefined) {
					if (typeof this[paneInfo.customSlider] === 'function') {
						let customOptions = this[paneInfo.customSlider].call(this, paneType, $pane) || {};
						Object.keys(customOptions).map(k => {
							paneInfo[k] = customOptions[k];
						});
					} else {
						console.log(`Missing implementation for "${paneInfo.customSlider}" pane customizable method.`)
					}
				}
				
				if (paneInfo.sliderFn != undefined) {
					if (typeof this[paneInfo.sliderFn] === 'function') {
						let sliderConf = {};
						if (paneInfo.sliderOptions != undefined) {
							sliderConf = paneInfo.sliderOptions;
						}
						let sliderOptions = this[paneInfo.sliderFn].call(this, sliderConf).call(this, paneType, $pane) || {};
						Object.keys(sliderOptions).map(k => {
							paneInfo[k] = sliderOptions[k];
						});
					} else {
						console.log(`Missing implementation for "${paneInfo.sliderFn}" pane customizable method.`)
					}
				}
				
				if (paneInfo.resizable == true || paneInfo.closable == true) {
					opts[`${paneType}__resizable`] = paneInfo.resizable;
					if (opts.onresize == undefined) {
						opts.onresize = function(paneName, pane, state, options, layoutName) {
							if (!this._ignoreLayoutResize) {
								// need to trigger 'resizePanel' to all visible panels inside each 'pane'
								$('.dashlet-panel', pane).each((i, panel) => {
									$.timeout(0).then(() => this._resizePanel(panel, true));
								});
								// need to register all tabs for resizing...
								$('.dashlet-tab-pane', pane).each((i, tab) => {
									if ($(tab).is(':visible')) {
										// resize immediately visible layout inside tab
										var pageLayout = $(tab).data('layout');
										if (pageLayout) {
											$.timeout(0).then(() => {
												this._ignoreLayoutResize = true;
												pageLayout.resizeAll();
												this._ignoreLayoutResize = false;
											})
										}
									} else {
										// hidden tabs will be resized on focus
										$(tab).data('to-be-resized', true);
									}
								});
							}
						}.bind(this)
					}
				}
				if (paneInfo.slidable != undefined) {
					opts[`${paneType}__slidable`] = paneInfo.slidable;
				}
				if (paneInfo.closable != undefined) {
					opts[`${paneType}__closable`] = paneInfo.closable;
				}
				if (paneInfo.spacing_open != undefined) {
					opts[`${paneType}__spacing_open`] = paneInfo.spacing_open;
				}
				if (paneInfo.spacing_closed != undefined) {
					opts[`${paneType}__spacing_closed`] = paneInfo.spacing_closed;
				}
				//togglerLength_open
				if (paneInfo.togglerLength_open != undefined) {
					opts[`${paneType}__togglerLength_open`] = paneInfo.togglerLength_open;
				}
				if (paneInfo.togglerLength_closed != undefined) {
					opts[`${paneType}__togglerLength_closed`] = paneInfo.togglerLength_closed;
				}
				if (paneInfo.init_closed != undefined) {
					opts[`${paneType}__initClosed`] = paneInfo.init_closed;
				}
				
			}.bind(this));

			// $container stuff
			if (typeof containerInfo.onresize == 'function') {
				opts['onresize'] = containerInfo.onresize.bind(this);
			}
			if (typeof containerInfo.onopen == 'function') {
				opts['onopen'] = containerInfo.onopen.bind(this);
			}

			$container.layout($.extend({}, commonOptions, opts));
		}.bind(this));

		// prefill all areas with simple panels, just for demo purposes
		$('.dashlet-area').each(function(i, area) {
			var $area = $(area);
			var paneInfo = $area.data('dashboardInfo');

			if ($area.children().length == 0 || $('.sample', $area).exists()) {
				var $sample = $('.sample', $area).detach();
				var panel = $('<div class="dashlet-panel"><div class="dashlet-header">' + (paneInfo.title || $area.attr('id')) + '</div><div class="dashlet-content"></div></div>');
				$area.append(panel);
				if ($sample.exists()) {
					var $fieldSet = $('<fieldset class="dashlet-fieldset ui-widget ui-widget-content ui-corner-bottom"></fieldset>');
					$fieldSet.append($sample);
					$('.dashlet-content', panel).append($fieldSet);
				}
			}
		});

		$customLayouts.addClass('ui-helper-hidden');
	},
	addOpenedSlider: function(options) {
		options = $.extend(options, {
			closed: false,
		})
		return this.addSlider(options);
	},
	addClosedSlider: function(options) {
		options = $.extend(options, {
			closed: true,
		})
		return this.addSlider(options);
	},
	addSlider: function(options) {
		options = $.extend({
			useBreakpoint: true,
			onlyChromaFlow: true,
			width: 1200,
			closed: false,
			spacingOpen: 6,
			spacingClosed: 15,
			length: 300,
		}, options);
		return (paneType, $pane) => {
			let br = $.pgwBrowser();
			let visibility = options.onlyChromaFlow ? this.usingChromaFlow() : true;
			let breakPoint = options.useBreakpoint ? (br.viewport.width < options.width) : true;
			if (breakPoint && visibility) {
				return {
					resizable: false,
					slidable: true,
					closable: true,
					init_closed: options.closed,
					spacing_open: options.spacingOpen,
					spacing_closed: options.spacingClosed,
					togglerLength_open: options.length,
					togglerLength_closed: options.length
				};
			}
		}
	},
	convertSize: function(panelSize, hasWideSkin) {
		let nSize;
		if(typeof panelSize === 'string') {
			nSize = parseFloat(panelSize);
		} else {
			nSize = panelSize;
		}
		
		if (nSize > 1 && hasWideSkin) {
			nSize = nSize + 16;	
		}
		
		/**
		 * needed to convert fixed widths or heights for compatibility with layoutSize
		 * It will be applied only in 'chromaFlow'
		 */
		if(nSize > 1) {
			nSize = this.adaptSize(nSize);
		}
		
		return nSize;
	},
	/**
	 * 'size' is for 'small' size. It will be converted to current size, taking account of a possible 'constantSize'
	 */
	adaptSize: function(size, options) {
		const keepIt = (v) => (typeof v === 'string') && (v.includes('%') || v == 'auto');
		options = $.extend({
			constantSize: 0, 
			originalLayoutSize: 'small',
			decimalPrecision: 4,
			appendAsUnit: undefined
		}, options);
		if(this.usingChromaFlow() && !keepIt(size)) {
			let adaptedSize = size;
			const currentLayoutSize = this.toolbox.get('globals.prefs.tenant.layout.theme.layoutSize', hrd, options.originalLayoutSize);
			if(options.originalLayoutSize != currentLayoutSize) {
				size = (typeof size === 'string' && (!size.includes('%') || size != 'auto')) ? parseFloat(size) : size;
				let originalFactor = getSizeByType(options.originalLayoutSize);
				let targetFactor = getSizeByType(currentLayoutSize);
				let variableSize = size - options.constantSize;
				adaptedSize = ((variableSize / originalFactor) * targetFactor) + options.constantSize;
				adaptedSize = adaptedSize.toFixed(options.decimalPrecision);
				adaptedSize = options.appendAsUnit ? `${adaptedSize}${options.appendAsUnit}` : adaptedSize;
			}
			return adaptedSize;
		} else {
			return size;
		}
	},
	getMainLayout: function() {
		return this.$mainLayout.layout();
	},
	doAutoTabs: function() {
		const usingChromaFlow = this.usingChromaFlow();

		// tabs preparations
		$('.layout-tab').each((i, tab) => {
			var $tab = $(tab);
			this.registerTab(tab);
			this.addTabScroll(tab);

			function debounce(func, delay) {
				let timer;
				return function(event) {
					if (timer) {
						clearTimeout(timer);
					}

					timer = setTimeout(func, delay, event);
				};
			}

			window.addEventListener('resize', debounce(() => {
				this.addTabScroll(tab);
			}, 250));

			// add listener to any tab pane in order to invoke 'resize' to each inner dashlet, but only if really needed
			$tab.children('.dashlet-tab-panes').children('.dashlet-tab-pane').each((i, pane) => {
				var $pane = $(pane);

				/* to be executed on first activation, use 'one' with tab-shown too because useful for first tab when 'invisible' */
				$pane.one('tab-activated tab-shown', evt => {
					this.addTabScroll(evt.currentTarget);

					$('.dashlet-panel', evt.currentTarget).each((i, panel) => {
						this._resizePanel(panel, false);
					});
				});
				/* to be executed each time the tab is focuses */
				$pane.on('tab-focus', evt => {
					var shouldBeResized = $pane.data('to-be-resized');
					// remove data because already used
					$pane.removeData('to-be-resized');

					if (shouldBeResized) {
						var pageLayout = $pane.data('layout');
						if (pageLayout) {
							this._ignoreLayoutResize = true;
							pageLayout.resizeAll();
							this._ignoreLayoutResize = false;
						}
						$('.dashlet-panel', evt.currentTarget).each((i, panel) => {
							this._resizePanel(panel, true);
						});
					}
				});

				if(usingChromaFlow && $pane.is(':visible')) {
					// need to force resize for the 'initial' tab. executed once first time only
					$pane.data('to-be-resized', true);
					$pane.trigger('tab-focus');
				}
			});

			// register tab-actions
			let actionButtons = $tab.children('.dashlet-tab-controls').find('button[data-action]');
			actionButtons.each((i, btn) => {
				var $btn = $(btn);
				var action = $btn.data('action');
				$btn.css('box-sizing', 'content-box');
				var id = $btn.uniqueId().attr('id'); // add unique-id if not yet available
				var buttonOptions = {
					icons: {
						primary: $btn.data('iconPrimary') != undefined ? 'f-icon ' + $btn.data('iconPrimary') : undefined,
						secondary: $btn.data('iconSecondary') != undefined ? 'f-icon ' + $btn.data('iconSecondary') : undefined,
					},
					text: $btn.data('showText') || false,
					disabled: $btn.data('disabled') || false
				};
				$btn.addClass('dashlet-button').button(buttonOptions);
				//data-visibile-only-for
				if (typeof this[action] === 'function') {
					var extraArg = $btn.data('options') ? $.evaluate($btn.data('options'), this) : undefined;
					$btn.off('click.tab-button').on('click.tab-button', (event) => {
						$btn.button('disable');
						var $panel = $('.dashlet-panel', this.getActiveTabPanel($tab.attr('id')));
						var r = this[action].apply(this, [event, $btn, $panel, extraArg]);
						return $.when(r).then((ignore) => {
							ignore = ((ignore === true) ? true : false) || (!!$btn.data('ignoreActivateOnReturn'));
							if (!ignore) {
								$btn.button('enable');
							}
						}).fail(() => {
							// when is rejected, always enable the button
							$btn.button('enable');
						});
					});
				} else {
					console.log(`The action "${action}" is not defined. Please add it to "${this._FULL_}"`);
				}
			});

			var toggableButtons = actionButtons.filter('button[data-visibile-only-for]');
			if (toggableButtons.length > 0) {
				// devo settare la visibilità iniziale
				toggableButtons.each((i, btn) => this.toggleTabButtonAction($(btn), this.getActiveTabPanelId($tab.attr('id'))));
				// esistono tab button action. devo abilitare la visibilità dinamica. devo attaccare il tab-changed listener
				$tab.on('tab-changed', (evt, ui) => {
					var tabId = ui.newPanel.attr('id');
					toggableButtons.each((i, btn) => this.toggleTabButtonAction($(btn), tabId));
				});

			}
		});
	},
	toggleTabButtonAction: function($btn, tabId) {
		var visibileOnlyFor = $btn.data('visibileOnlyFor').split(',').map(t => t.trim());
		$btn.toggle(visibileOnlyFor.includes(tabId));
	},
	doAutoPanels: function() {
		// need to filter panels used in layout in dialogs
		$('.dashlet-panel')
			.filter((i, panel) => {
				return !$(panel).closest('*[data-layout-in-dialog]').exists();
			})
			.each(function(i, panel) {
				var $panel = $(panel);
				var options = {
					collapsible: false
				};
				var controlsId = $panel.data('controlsId');
				var panelize = true;
				if (controlsId !== undefined) {
					options.controls = $('#' + controlsId).detach().html();
				} else {
					var dashletData = $panel.data('dashlet');
					if (dashletData != undefined) {
						var info = $.evaluate($panel.data('dashlet'), this);
						if (info) {
							if (info.type === 'panel' && info.controls) {
								controlsId = info.controls;
								options.controls = $('#' + controlsId).detach().html();
							}
							panelize = !info.isTab;
						}
					}
				}
				if (panelize) {
					$panel.panel(options);
				} else {
					$panel.addClass('in-tab');
				}
				// initialize panel buttons... if needed
				if (controlsId !== undefined) {
					/* prepare each button in button bar */
					$('.dashlet-header button, .dashlet-header input', $panel).each(function(j, button) {
						var $button = $(button);
						var $label;
						/* if the button is an input, label must be connected properly */
						if (button.tagName == 'INPUT') {
							if ($button.attr('type') == undefined) {
								button.type = 'checkbox';
							}
							$label = $button.next('label');
							var bid = $button.uniqueId().attr('id');
							$label.attr('for', bid);
							$button.data('label', $label);
						}

						var buttonOptions = {
							icons: {
								primary: $button.data('iconPrimary') != undefined ? 'f-icon ' + $button.data('iconPrimary') : undefined,
								secondary: $button.data('iconSecondary') != undefined ? 'f-icon ' + $button.data('iconSecondary') : undefined,
							},
							text: $button.data('showText') || false,
							disabled: $button.data('disabled') || false
						};

						//check Role permissions
						var roleInfo = $button.data('roleInfo');
						var id = $button.data('action') || $button.uniqueId().attr('id'); // add uniqueid if not yet available
						if (roleInfo == undefined) {
							if ($button.data('role')) {
								roleInfo = $.evaluate($button.data('role'));
								$button.data('roleInfo', roleInfo);
							}
						}
						if (roleInfo != undefined && roleInfo.role) {
							dashboardInstance.addPermission(id, roleInfo.role).then(() => {
								if (!dashboardInstance.hasPermission(id) && roleInfo.role != undefined) {
									$button.hide();
								}
							});
						}
						var hideExpr = $button.data('hide');
						if (hideExpr != undefined) {
							var hideValue = $.evaluate(hideExpr);
							$button.toggle(!hideValue);
							if ($label) {
								$label.toggle(!hideValue);
							}
						}
						$button.addClass('dashlet-header-button').button(buttonOptions);
					});
				}
			});
	},
	resize: function(redraw) {
		/*
		if(redraw) {
			this.renderResponsiveDashletsIf((currentDevice, targetDevice) =>
				currentDevice !== targetDevice
			);
		}
		*/

		this.adjustPanels();
		if (this.automatic) {
			if (redraw) {
				$('.dashlet-tab-pane:not(:visible)').each(function(i, tab) {
					$(tab).data('to-be-resized', true);
				});
			}
			var needToResizeOldStuff = false;
			$('.dashlet-panel:not(.recycle-bin):visible').each(function(i, panel) {
				var isOldStuff = this._resizePanel(panel, true, true);
				needToResizeOldStuff = isOldStuff || needToResizeOldStuff;
			}.bind(this));

			if (needToResizeOldStuff) {
				hrd.dashboard.dashlet.resize();
				hrd.datatable.resize(redraw);
			}
		} else {
			hrd.dashboard.dashlet.resize();
			hrd.datatable.resize(redraw);
		}
		/* set to false the convenience variable in order enable layout resize to work properly when a pane is resized*/
		this._ignoreLayoutResize = false;
	},
	/**
	 * just needed to resize panels after loading dashlets, because some elements can have different dimensions (like panel-header)
	 */
	resizeOnlyPanels: function() {
		if (this.automatic) {
			$('.dashlet-panel:not(.recycle-bin):visible').each(function(i, panel) {
				this._resizePanel(panel, false);
			}.bind(this));
		}
	},
	adjustPanels: $.noop,
	autoAdjustPanels: function(options) {
		options = options || {};
		if (!this.alreadyDone) {
			var fieldSet = '<fieldset class="dashlet-fieldset ui-widget ui-widget-content ui-corner-bottom"></fieldset>';
			$('.dashlet-content > .ui-panel-content-text').each(function(index, content) {
				if (!$(content).children().length > 0) {
					$(content).append($(fieldSet));
				}
			})
			this.alreadyDone = true;
		}
		if (!this.automatic) {
			// only for legacy dashboards with the innovative use of autopanels
			$('.dashlet-panel:not(.recycle-bin):visible').each(function(i, panel) {
				this._resizePanel(panel, false);
			}.bind(this));
		}

		/* needed for ajusting tabs heights, but only for legacy tabs (28/02/2019: no need to use legacyTabs, because must be computed everytime)*/
		//if(options.legacyTabs === true){
		// moved above, before layout computation
		/*
		$('.dashlet-tab').each(function(i, tab){
			var $tab = $(tab);
			var $tabLinks = $tab.children('ul');
			var tabLinksHeight = $tabLinks.outerHeight(true) == 0 ? '25' : $tabLinks.outerHeight(true); // 25px is needed because of nested tabs used inside a tab initially invisible
			$tab.children('div.dashlet-tab-panes').css('height', 'calc( 100% - ' + tabLinksHeight + 'px )');
			$tab.children('div.dashlet-tab-panes').children('div').addClass('full-height');
		});
		*/
		//}
	},
	_resizePanel: function(panel, executeDashletResize, redraw) {
		redraw = !!redraw;
		var $panel = $(panel);
		var isOldStyleDashlet = $panel.data('dashlet') == undefined;
		if ($panel.is(':visible')) {
			var content = $('.dashlet-content', $panel);
			var header = $('.dashlet-header', $panel);
			var footer = $('.dashlet-footer', $panel);
			hrd.dashboard.dashlet.adjustPanelSize(content, $panel.parent(), header, footer);

			// try to invoke dashlet.resize
			executeDashletResize = (executeDashletResize == undefined) ? true : executeDashletResize;
			if (executeDashletResize && !isOldStyleDashlet) {
				var dashletInstance = $panel.data('dashletInstance');
				if (dashletInstance) {
					dashletInstance.doResize(redraw);
				}
			}
		}
		return isOldStyleDashlet;
	},
	registerEvents: $.noop,
	autoRegisterEvents: function(namespace, externallyEmittedEvents, externallyListenedEvents) {
		if (this.dashlets) {
			this.externallyEmittedEvents = externallyEmittedEvents || [];
			this.externallyListenedEvents = externallyListenedEvents || [];
			var emittableEvents = this.externallyEmittedEvents.map(e => e);
			/* prepare emitting events */
			$.each(this.dashlets, function(key, dashlet) {
				dashlet.emitting(emittableEvents); // modifica per side effect
			});
			emittableEvents = hrd.utils.uniqueArray(emittableEvents);
			// collecting intercom event mappings
			var emittingIntercomEvents = [];
			this.emittingIntercomMap = {};
			this.intercomEmitMappings(emittingIntercomEvents);
			emittingIntercomEvents.forEach(mapping => {
				this.emittingIntercomMap[mapping.from] = mapping;
			});

			this.listeningIntercomEvents = [];
			this.intercomListenMappings(this.listeningIntercomEvents);

			//manage all
			this.dispatchEvents(emittableEvents, namespace);
		}
	},
	dispatchEvents: function(events, namespace) {
		namespace = namespace ? '.' + namespace : '.dashboard-dispatcher';
		var sEvents = $.map(events, evt => evt + namespace).join(' ');

		$('body')
			.off(namespace)
			.on('presentation-config-changed', () => this.intercom.emit('presentation-config-changed'))
			.on(sEvents, function(event, data, intercomInfo) {
				var promises = [];
				$.each(this.dashlets, function(key, dashlet) {
					if (dashlet.isListeningTo(event.type)) {
						promises.push($.chainableBroadcast(dashlet.PANEL_ID, event.type, data));
					}
				});
				// looking for a method in dashboard with 'proper name'
				var myEventHandler = $.functionCase(event.type + '-handler');
				if (typeof this[myEventHandler] == 'function') {
					this[myEventHandler].call(this, data);
				}

				// dispatching events mapped with intercom emitting events
				var intercomMappedEvent = this.emittingIntercomMap[event.type];
				if (intercomMappedEvent !== undefined) {
					// used to avoid loops
					if (intercomInfo == undefined || intercomInfo.origin != this.intercom.origin) {
						// query emit
						var canEmitPromise = $.when(true);
						if (typeof intercomMappedEvent.queryEmit == 'function') {
							canEmitPromise = $.when(intercomMappedEvent.queryEmit.call(this, data));
						}
						canEmitPromise.then(canEmit => {
							if (canEmit) {
								if (typeof intercomMappedEvent.adaptData == 'function') {
									data = intercomMappedEvent.adaptData.call(this, data);
								}
								if (intercomMappedEvent.topOnly) {
									this.intercomEmitToParentContainer(intercomMappedEvent.to, data);
								} else if (intercomMappedEvent.withStamp) {
									this.intercomEmitWithStamp(intercomMappedEvent.to, data);
								} else {
									this.intercom.emit(intercomMappedEvent.to, data);
								}
							}
						});
					}
				}
				return $.when.all(promises);
			}.bind(this));

		this.intercom.on('presentation-config-changed', () => this.applyPresentationConfig());

		// intercom registering for 'listenings'
		this.listeningIntercomEvents.forEach(mapping => {
			const fn = (info) => {
				var canBroadcast = true
				if (typeof mapping.queryBroadcast == 'function') {
					canBroadcast = mapping.queryBroadcast.call(this, info);
				}
				if (canBroadcast) {
					let p;
					if (typeof mapping.adaptData == 'function') {
						p = $.when(mapping.adaptData.call(this, info));
					} else {
						p = $.when(info);
					}
					p.then(data => $.emitMulti(mapping.to, data, { origin: this.intercom.origin }));
				}
			};
			if (mapping.withStamp) {
				this.intercomOnWithStamp(mapping.from, fn);
			} else {
				this.intercom.on(mapping.from, fn);
			}
		});
	},
	intercomEmitMappings: $.noop,
	intercomListenMappings: $.noop,
	intercomEmitToParentContainer: function(event, data) {
		if (hrd.utils.inIFrame()) {
			let topIntercom = window.top['Intercom'].getInstance();
			this.intercom.emit(event, $.extend(data, { target: topIntercom.origin, origin: this.intercom.origin }));
		} else {
			console.log(`The event '${event}' cannot be triggered in this scope`);
		}

	},
	intercomEmitWithStamp: function(event, data) {
		data = data || {};
		data.origin = this.intercom.origin;
		this.intercom.emit(event, data, data);
	},
	intercomOnWithStamp: function(event, fn) {
		this.intercom.on(event, data => {
			if (data.target === this.intercom.origin) {
				fn(data);
			}
		});
	},
	_availableDashlets_: function() {
		$.each(this.dashlets, k => console.log(k))
	},
	_debugEvents_: function() {
		if (this.dashlets) {
			var e = hrd.utils.uniqueArray(Object.values(this.dashlets).reduce((a, d) => { d.emitting(a); return a; }, []));
			var l = hrd.utils.uniqueArray(Object.values(this.dashlets).reduce((a, d) => { d.listening(a); return a; }, []));
		}
		console.log();
		console.log('------------- listening ---------------');
		console.log();
		$.each(e, (i, ev) => {
			this._listeningMap(ev);
		});
		$.each(this.externallyEmittedEvents, (i, ev) => {
			this._listeningMap(ev);
		});
		console.log();
		console.log('------------- emitting ----------------');
		console.log();
		$.each(l, (i, ev) => {
			this._emittingMap(ev);
		});
		$.each(this.externallyListenedEvents, (i, ev) => {
			this._emittingMap(ev);
		});
	},
	_eventsMap: function(specificEvent) {
		console.log('--- EMITTING ---');
		this._emittingMap(specificEvent);
		console.log('--- LISTENING ---');
		this._listeningMap(specificEvent);
	},
	_emittingMap: function(specificEvent) {
		if (this.dashlets) {
			if (specificEvent == undefined) {
				console.log('Events emitted by dashlets')
				$.each(this.dashlets, (k, d) => {
					var a = [];
					d.emitting(a);
					console.log(d._NAME_ + ': ' + a.join(', '));
				});
			} else {
				var ds = []
				$.each(this.dashlets, (k, d) => {
					var a = [];
					d.emitting(a);
					if (a.indexOf(specificEvent) != -1) {
						ds.push(d._NAME_);
					}
				});
				if (ds.length > 0) {
					console.log('Dashlets emitting to "' + specificEvent + '" :' + ds.join(', '));
				} else {
					if (this.externallyEmittedEvents.indexOf(specificEvent) == -1) {
						console.error('NO Dashlets are emitting "' + specificEvent + '"');
					} else {
						console.info('Event emitted from outside: "' + specificEvent + '"');
					}
				}
			}
		} else {
			console.log('No dashlets available');
		}
	},
	_listeningMap: function(specificEvent) {
		if (this.dashlets) {
			if (specificEvent == undefined) {
				console.log('Events listened by dashlets')
				$.each(this.dashlets, (k, d) => {
					var a = [];
					d.listening(a);
					console.log(d._NAME_ + ': ' + a.join(', '));
				});
			} else {
				var ds = []
				$.each(this.dashlets, (k, d) => {
					var a = [];
					d.listening(a);
					if (a.indexOf(specificEvent) != -1) {
						ds.push(d._NAME_);
					}
				});
				if (ds.length > 0) {
					console.log('Dashlets listening to "' + specificEvent + '" :' + ds.join(', '));
				} else {
					if (this.externallyListenedEvents.indexOf(specificEvent) == -1) {
						console.error('NO Dashlets are listening "' + specificEvent + '"');
					} else {
						console.info('Event listened outside: "' + specificEvent + '"');
					}
				}
			}
		} else {
			console.log('No dashlets available');
		}
	},
	loadDashlets: $.noop,
	autoLoadDashlets: function() {
		$('*[data-dashlet]').each(function(i, panel) {
			var $panel = $(panel);
			var info = $.evaluate($panel.data('dashlet'), this);
			if (info.type === 'panel') {
				$panel.data('dashletInfo', info);
				var impl = eval(info.impl);
				if (typeof impl === 'function') {
					var instanceRef = $.camelCase(info.prefix);
					var dashletOptions = {
						impl: info.impl,
						prefix: info.prefix,
						dashboard: this
					};
					if (info.options) {
						dashletOptions = $.extend(dashletOptions, info.options);
					}
					var dashlet = $.evaluate('new impl(panel, opts)', this, [eval(info.impl), $panel, dashletOptions], ['impl', 'panel', 'opts']);
					this.registerDashlet(instanceRef, dashlet);
					/** prepare button controls **/
					if (info.controls) {
						dashlet.controls = {};
						const _toggleItemByNameFn = ($menu, itemName, toggle) => {
							let item = $(`li[data-menu-type="${itemName}"]`, $menu);
							if (item.exists()) {
								_toggleItemFn(item, toggle);
							}
						};
						const _toggleEnableItemByNameFn = ($menu, itemName, toggle) => {
							let item = $(`li[data-menu-type="${itemName}"]`, $menu);
							if (item.exists()) {
								_toggleEnableItemFn(item, toggle);
							}
						};
						const _toggleItemFn = (item, toggle) => {
							if (toggle) {
								item.show();
								item.removeClass('hidden-item');
							} else {
								item.hide();
								item.addClass('hidden-item');
							}
						};
						const _toggleEnableItemFn = (item, toggle) => {
							if (toggle) {
								item.removeClass('ui-state-disabled');
							} else {
								item.addClass('ui-state-disabled');
							}
						};
						$('.dashlet-header button, .dashlet-header input', $panel).each((_, button) => {
							var $button = $(button);
							var action = $button.data('action');
							if (action) {
								if (typeof dashlet[action] === 'function') {
									var extraArg = $button.data('options') ? $.evaluate($button.data('options'), dashlet) : undefined;
									$button
										.off('click.header-button')
										.on('click.header-button', (event) => {
											$button.button('disable');
											var r = dashlet[action].apply(dashlet, [event, $button, extraArg]);
											return $.when(r).then((ignore) => {
												ignore = ((ignore === true) ? true : false) || (!!$button.data('ignoreActivateOnReturn'));
												if (!ignore) {
													$button.button('enable');
												}
											}).fail(() => {
												// when is rejected, always enable the button
												$button.button('enable');
											});
										});
								} else if ($button.data('menu') != undefined) {
									var dataMenu = $button.data('menu');
									var $menu = $(`#${dataMenu}`);
									var actionMenu = $.functionCase('dispatcher-menu-action');
									if ($menu.exists()) {
										$('body').append($menu.detach());

										$menu.toggleItem = (itemName, toggle) => _toggleItemByNameFn($menu, itemName, toggle);
										$menu.toggleEnableItem = (itemName, toggle) => _toggleEnableItemByNameFn($menu, itemName, toggle);

										let actionMenuBeforeCreateFn = undefined;
										if ($button.data('menuBeforeCreate') != undefined) {
											let actionMenuBeforeCreate = $.functionCase(action + '-menu-before-create');
											if (typeof dashlet[actionMenuBeforeCreate] === 'function') {
												actionMenuBeforeCreateFn = dashlet[actionMenuBeforeCreate];
											} else {
												console.log(`Function "${actionMenuBeforeCreate}" not available in proper object reference "${dashlet._FULL_}"`);
											}
										}

										let actionMenuBeforeOpenFn = undefined;
										if ($button.data('menuBeforeOpen') != undefined) {
											let actionMenuBeforeOpen = $.functionCase(action + '-menu-before-open');
											if (typeof dashlet[actionMenuBeforeOpen] === 'function') {
												actionMenuBeforeOpenFn = dashlet[actionMenuBeforeOpen];
											} else {
												console.log(`Function "${actionMenuBeforeOpen}" not available in proper object reference "${dashlet._FULL_}"`);
											}
										}

										let beforeCreatePromise;
										if (actionMenuBeforeCreateFn != undefined) {
											beforeCreatePromise = $.when(actionMenuBeforeCreateFn.call(dashlet, $menu));
										} else {
											beforeCreatePromise = $.when();
										}

										beforeCreatePromise
											.then(additionalItems => {
												additionalItems = additionalItems || [];
												additionalItems.forEach(block => {
													let placeholder = $(`#${block.id}`, $menu);
													block.list.forEach(item => {
														let newItem;
														if (item.isDivider) {
															newItem = `<li>-</li>`;
														} else {
															let extraArsg = item.extraArgs ? ` data-extra-args='${JSON.stringify(item.extraArgs)}'` : '';
															let permission = item.permission ? ` data-permission="${item.permission}" ` : '';
															let style = item.style ? ` style="${item.style}" ` : '';
															let hide = item.hide != undefined ? `data-hide="${item.hide}"` : '';
															newItem = $(`<li data-menu-type="${item.type}"${extraArsg}${permission}${hide}${style}><a href="#" onclick="return false;">${item.label}</a></li>`);
														}
														placeholder.before(newItem);
													})
													placeholder.remove();
												})
											})
											.then(() => {
												/* apply permissions if needed */
												$('li[data-menu-type]', $menu).each((_, item) => {
													let $item = $(item);
													let key = $item.data('keyLabel');
													let label = $item.data('label');
													if (this.toolbox.isNotEmpty(key) || this.toolbox.isNotEmpty(label)) {
														label = label || xlate(key);
														let content = `<a href="#" onclick="return false;">${label}</a>`;
														$item.html(content);
													}
													let isHidden = false;
													let hideExpr = $item.data('hide');
													if (hideExpr != undefined) {
														let hideValue = $.evaluate(hideExpr, dashlet);
														_toggleItemFn($item, !hideValue);
														isHidden = hideValue;
													}

													let itemPermission = $item.data('permission');
													if (itemPermission && !isHidden) {
														if (dashboardInstance.hasPermissionData(itemPermission)) {
															_toggleItemFn($item, dashboardInstance.hasPermission(itemPermission));
														} else {
															console.log(`Permission "${itemPermission}" has been added to item "${$item.data('menu-type')}", but it is not defined in dashboard permission list`);
														}
													}
												});

												if ($button.is(':visible') || ($button.data('hide') == undefined)) {
													// here if visible or if button does not have 'data-hide' feature 
													//check if the menu has visible items.... if not the button will be hidden
													var hasVisibleItems = $('li[data-menu-type]:not(".hidden-item")', $menu).length != 0;
													$button.toggle(hasVisibleItems);
												}
												/* --------------------------- */

												$button.off('click.header-button').on('click.header-button', (event) => {
													// close tooltip
													$button.tooltip().tooltip("close");
													// close all other menu instances

													if ($('.ui-menu').closest('.chroma-flow').exists()) {
														$('.ui-menu')
															.attr('data-state', 'closed')
															.addClass('closed');
													} else {
														$('.ui-menu').hide();
													}

													var menuCssOptions = {
														'position': 'absolute',
														'z-index': '100',
														top: 'unset',
														bottom: 'unset',
														left: 'unset',
														right: 'unset',
													};
													if ($menu.data('width')) {
														let w = this.adaptSize($menu.data('width'), {decimalPrecision: 0});
														menuCssOptions.width = w;
													}
													if ($menu.data('height')) {
														let h = this.adaptSize($menu.data('height'), {decimalPrecision: 0});
														menuCssOptions.height = h;
													}
													$menu
														.menu({
															select: (evt, ui) => {
																let args = [action, ui.item.attr('data-menu-type'), ui.item]
																let extraArgs = ui.item.data('extraArgs');
																if (extraArgs != undefined) {
																	args.push(extraArgs);
																}
																dashlet[actionMenu].apply(dashlet, args);
															}
														});

													if ($menu.closest('.chroma-flow').exists()) {
														$menu
															.addClass('popover command');

														let $itemsToGroup = null;

														$('.ui-menu-item', $menu).each((i, item) => {
															const $item = $(item);

															if ($item.parent('.group, .ui-menu-group').exists()) return;

															if ($itemsToGroup === null || $itemsToGroup === undefined) {
																$itemsToGroup = $();
															}

															if($item.is(':visible')) {
																$itemsToGroup = $itemsToGroup.add(item);
															}

															if (!$item.next().exists() || $item.next().is('.ui-menu-divider')) {
																$itemsToGroup.wrapAll('<div class="ui-menu-group"></div>');
																$itemsToGroup = null;
															}
														});
													}

													let beforeOpenPromise;
													if (actionMenuBeforeOpenFn != undefined) {
														beforeOpenPromise = $.when(actionMenuBeforeOpenFn.call(dashlet, $menu));
													} else {
														beforeOpenPromise = $.when();
													}

													beforeOpenPromise.then(() => {
														// useful to remove 'rounded-corners' on selected elements when '2x'
														if ($menu.hasClass('items-2x')) {
															$('li[data-menu-type] a', $menu).each((i, item) => {
																$(item).removeClass('ui-corner-all');
															});
														}

														if(!$menu.closest('.chroma-flow').exists()) {
															/* now dividers must be managed in order to trim them (avoid start, end and double dividers */
															$('li.ui-menu-divider', $menu).each((i, divider) => {
																// trim leading divider
																var prevVisible = $(divider).prevAll('li:not(".hidden-item")').first();
																if (!prevVisible.exists()) {
																	//divider in first position
																	$(divider).hide();
																}
																// trim trailing divider
																var nextVisible = $(divider).nextAll('li:not(".hidden-item")').first();
																if (!nextVisible.exists()) {
																	//divider in last position
																	$(divider).hide();
																}

																// trim internal double dividers, keeping the firts
																var nextAll = $(divider).nextAll('li:not(".hidden-item")');
																nextAll.each((i, n) => {
																	if ($(n).hasClass('ui-menu-divider')) {
																		$(n).hide();
																		if (i == nextAll.length - 1) {
																			// the last element is a divider.... so because no good element found, need to hide main divider too
																			$(divider).hide();
																		}
																	} else {
																		return false; // stop hiding, a good item has been found
																	}
																});
															});
														} else {
															const $first = $('.ui-menu-group:visible:first', $menu);
															const $last = $('.ui-menu-group:visible:last', $menu);

															$first
																.prevAll('.ui-menu-divider')
																.addClass('ui-helper-hidden-important');

															$last
																.nextAll('.ui-menu-divider')
																.addClass('ui-helper-hidden-important');
														}
														/**/

														$menu.show().css(menuCssOptions).position({
															my: "left top",
															at: `left bottom+4`,
															of: $button
														});

														if ($menu.closest('.chroma-flow').exists()) {
															$menu
																.removeClass('closed')
																.attr('data-state', 'open');
														}
													});
													$(document).one('click', (event) => {
														if ($menu.closest('.chroma-flow').exists()) {
															$menu.attr('data-state', 'closed');
														} else {
															$menu.hide();
														}
													});
													event.stopPropagation(); //needed for viewing the drop down menu

													if ($menu.closest('.chroma-flow').exists()) {
														$('.ui-menu')
															.off('.animation')
															.on('animationend.animation', (event) => {
																event.stopPropagation();

																const isClosed = $(event.target).attr('data-state') === 'closed';
																$(event.target).toggleClass('closed', isClosed);
															});
													}
												});

											})

									} else {
										console.log(`Menu definition with id "${dataMenu}" NON FOUND`);
									}
								} else {
									console.log(`The action "${action}" is not defined for dashlet "${info.impl}". Please add it or add "data-menu" attribute for defining a control menu`);
								}
								dashlet.controls[action] = $button;
							}
						});
					}
					/******************************/
					/** prepare listening events **/
					var listeningEvents = [];
					dashlet.listening(listeningEvents);
					dashlet.listeningEvents = listeningEvents;
					/******************************/
					// registering instance in panel for future use
					$panel.data('dashletInstance', dashlet);
					dashlet.doDashlet();
					if (info.activate === true) {
						dashlet.doActivated();
					}
				} else {
					hrd.dashboard.errorDialog(`The dashlet class <b style="font-size:larger;">${info.impl}'</b> has not been defined yet`);
				}
			};
		}.bind(this));
	},
	/** needed to register dashlet in dashboard and viceversa */
	registerDashlet: function(key, reference) {
		this.dashlets = this.dashlets || {};
		this.dashlets[key] = reference;
	},
	postLoad: function() {
		$(document).ajaxComplete((event, request, settings) => {
			var lastCall = $.active == 1;
			if (lastCall) {
				$.timeout(0).then(() => this.postLoadExec());
			}
		})
			;
	},
	postLoadExec: function() {
		var buttons = $("button:not([data-prevent-default]), input[type='button'], input[type='submit']");
		buttons = buttons.filter((i, btn) => (!$(btn).closest('.do-not-touch-inner-buttons').exists()));
		$(buttons).button().off('mouseup.ple').on('mouseup.ple', function() {
			$(this).blur(); // prevent jquery ui button from remaining in the active state
		});
		/* register to all timepickers a change event for formatting properly */
		$('.time-field:not(.ignore-on-blur)').on('blur', function() {
			var prevValue = $(this).data('prev-val');
			var currentValue = $(this).val();
			if (prevValue !== currentValue) {
				$(this).val(hrd.utils.formatTime(currentValue));
			}
		});
		/* tooltips: labels too long will be ellipsed and toltipped */
		$('.dashlet-fieldset label:not(.table_cell_content)').on('mouseenter', function() {
			var $this = $(this);
			if (this.clientWidth < this.scrollWidth && !$this.attr('title')) {
				$this.attr('title', $this.text());
			}
		}).tooltip({
			track: false,
			open: function(event, ui) {
				setTimeout(function() {
					$(ui.tooltip).hide();
				}, 2000);
			}
		});

		/* other tooltips */
		$('.with-tooltip').tooltip({
			track: false,
			open: function(event, ui) {
				setTimeout(function() {
					$(ui.tooltip).hide();
				}, 2000);
			}
		});
		// run 'initComplete' only once
		if (!this.isDashboardInited) {
			/* detect if _additionalPermissionPromise has been resolved*/
			if (dashboardInstance._additionalPermissionDeferred && dashboardInstance._additionalPermissionDeferred.state() == 'pending') {
				dashboardInstance.evaluatePermissions(dashboardInstance._additionalPermission).then(function() {
					dashboardInstance._additionalPermissionDeferred.resolve();
					this.initComplete();
					this.isDashboardInited = true;
				}.bind(this));
			} else {
				this.initComplete();
				this.isDashboardInited = true;
			}
		}
	},
	downloadSnippets: function(snippets) {
		if ($.isPlainObject(snippets)) {
			var snippetPromises = Object.keys(snippets).map(k => {
				let uri, type;
				if (typeof snippets[k] === 'object') {
					uri = snippets[k].uri;
					type = snippets[k].type || 'normal';
				} else {
					uri = snippets[k];
					type = 'normal';
				}
				return this.invokeSnippet(uri)
					.then(html => {
						var o = {};
						o[k] = {
							uri: uri,
							snippet: html,
							type: type
						};
						return $.when(o);
					})
			});
			return $.when.all(snippetPromises).then(snips => snips.reduce((a, s) => $.extend(a, s), {}));
		} else {
			return $.when();
		}
	},
	getSnippet: function(name) {
		if (this.snippetData) {
			return this.snippetData[name].snippet;
		} else {
			return undefined;
		}
	},
	getSnippetInfo: function(name) {
		if (this.snippetData) {
			return this.snippetData[name];
		} else {
			return undefined;
		}
	},
	actualizeSnippet: function(name, data) {
		var snippet = this.getSnippet(name);
		if (snippet) {
			return hrd.utils.replaceParams(snippet, data);
		} else {
			return '';
		}
	},
	evaluatePermissions: function(permissions) {
		this._actualPermissions = this._actualPermissions || {};
		if (permissions != undefined) {
			var ps = $.map(permissions, function(v, k) {
				return k + '|' + v;
			});
			return this.invokeProvider('com.hrd.struts.SecurityRoleJsonProvider', 'evaluatePermissions', {
				permissions: ps
			}).then(function(response) {
				var actualPermissions = {};
				$.each(response.permissions, function(i, p) {
					actualPermissions[p.name] = p.isAllowed;
				})
				this._actualPermissions = $.extend(this._actualPermissions, actualPermissions);
				return $.when();
			}.bind(this));
		} else {
			return $.when();
		}
	},
	addPermission: function(key, role) {
		if (role != undefined) {
			if (this._additionalPermissionDeferred == undefined || this._additionalPermissionDeferred.state() != 'pending') {
				this._additionalPermissionDeferred = $.Deferred();
			}
			this._additionalPermission = this._additionalPermission || {};
			this._additionalPermission[key] = role;
			return this._additionalPermissionDeferred.promise();
		} else {
			return $.when();
		}
	},
	registerPermission: function(key, role) {
		if (role != undefined && this._actualPermissions[key] == undefined) {
			var deferred = $.Deferred();
			var permission = {};
			permission[key] = role;
			this.evaluatePermissions(permission).then(() => {
				deferred.resolve();
			});
			return deferred.promise();
		} else {
			return $.when();
		}
	},
	/* Useful to detect if a permission has been requested */
	hasPermissionData: function(key) {
		return !!(this._actualPermissions && this._actualPermissions[key] != undefined);
	},
	hasPermission: function(key) {
		var customFunction = $.functionCase(key + '-permission-helper');
		var fn = this[customFunction];
		var has = this._actualPermissions ? this._actualPermissions[key] === true : false;
		if (typeof fn == 'function') {
			var customEval = fn.call(this, has);
			if (customEval == undefined) {
				console.error('The function', customFunction, 'must return a boolean value');
				return has;
			} else {
				return !!customEval;
			}
		} else {
			return has;
		}
	},
	hasAllPermissions: function(keys) {
		var all = true;
		$.each(keys, function(i, key) {
			all = all && this.hasPermission(key);
		}.bind(this));
		return all;
	},
	hasOnePermission: function(keys) {
		var one = false;
		$.each(keys, function(i, key) {
			one = one || this.hasPermission(key);
		}.bind(this));
		return one;
	},
	/* utility generic methods */
	/**
	 * This is the height of TOP_AREA dashlet
	 */
	topAreaHeight: function() {
		let showTopArea = this.toolbox.get('globals.prefs.tenant.layout.showTopArea', hrd, true);
		return !showTopArea ? -1 : hrd.dashlets.topArea.getHeight ? hrd.dashlets.topArea.getHeight() : 32;
	},
	/**
	 * Tab specific utilities
	 */
	registerTab: function(tabContainer) {
		var $tabContainer = $(tabContainer);
		const usingChromaFlow = this.usingChromaFlow();

		$tabContainer.tabs({
			activate: function(event, ui) {
				var tabId = ui.newPanel.attr('id');
				if (!$(this).data(tabId)) {
					if(usingChromaFlow) {
						const $innerTab = $('.dashlet-tab:visible', $tabContainer);
						const $innerTabPane = $innerTab.find('.dashlet-tab-pane:visible').each((i, pane) => {
							$.timeout(0)
								.then(() => $(pane).trigger('tab-focus'));
						});
					}

					$.broadcast(ui.newPanel, 'tab-activated');
					$(this).data(tabId, true);
				} else {
					$.broadcast(ui.newPanel, 'tab-reactivated');
				}
				$.broadcast(ui.newPanel, 'tab-focus');
				$.broadcast(ui.oldPanel, 'tab-blur');
				$.broadcast(this, 'tab-changed', ui);
			}
		});
		// need to set as already activated
		var defaultTabIndex = $tabContainer.tabs('option', 'active');
		var defaultTabPane = $tabContainer.find('.ui-tabs-panel')[defaultTabIndex];
		$tabContainer.data($(defaultTabPane).attr('id'), true);

		// Stepper Activation
		const info = $tabContainer.data('dashboardInfo');

		if (info && info.isStepper) {
			$tabContainer.addClass('dashlet-tab-stepper');
			$tabContainer.tabs("disable");
			$tabContainer.tabs("enable", 0);

			$tabContainer.find('ul').addClass('stepper');
			// const $outsideTabs = $tabContainer.find('ul.stepper > [data-step-outside="true"]').detach();
			const $outsideTabs = $tabContainer.find('ul.stepper > [data-step-outside="true"]');

			if ($outsideTabs.exists()) {
				const $stepper = $tabContainer.find('ul.stepper');
				const $stepsCount = $('li:not([data-step-outside="true"])', $stepper).length;

				$outsideTabs.each((i, tab) => {
					const $tab = $(tab);

					// $stepper.prepend($tab);
					$tab.addClass('step--outside');
					this.enableTabByIndex($tabContainer.attr('id'), ($stepsCount + i));
				});
			}

			$tabContainer.find('ul.stepper li:not(.step--outside)').last().addClass('step--final');
			$tabContainer.find('ul.stepper li').each((i, tab) => {
				const $tab = $(tab);
				const iconClass = $tab.data('iconStep') || 'fas fa-chevron-right';
				const $a = $tab.find('a');
				const text = $a.html();

				$a.html(`
					<i class="f-icon ${iconClass}"></i>
					<p>${text}</p>
				`);

				$tab.addClass('step');
			});
		}
	},
	addTabNavigation: function(tabContainer) {
		const $tabContainer = $(tabContainer);
		const $tabLists = $('.dashlet-tabs', $tabContainer);

		$tabLists.each((listsIndex, tabList) => {
			const $tabList = $(tabList);
			let $tabNavigation = $('.tab__navigation', $tabList);

			if (!$tabNavigation.exists() && $tabList.get(0).offsetWidth < $tabList.get(0).scrollWidth) {
				const $tabs = $('li', $tabList);
				let $activeTab = $('li.ui-state-active', $tabList);
				const tabListBoundingClientRect = $tabList.get(0).getBoundingClientRect();

				$tabList.addClass('dashlet-tabs--navigable');

				$tabList.prepend(`
					<div class="tab__navigation">
						<button class="tab__prev">
							<i class="fas fa-angle-left"></i>
						</button>
						<button class="tab__next">
							<i class="fas fa-angle-right"></i>
						</button>
					</div>
				`);

				$tabNavigation = $('.tab__navigation', $tabList);
				$tabList.css({
					'padding-left': $tabNavigation.width()
				});

				$('.ui-tabs-anchor', $tabList)
					.off('.nav')
					.on('click.nav', (event) => {
						$activeTab = $(event.currentTarget).parent();
						const activeTabBoundingClientRect = $activeTab.get(0).getBoundingClientRect();
						const activeTabLeftOffset = activeTabBoundingClientRect.left - tabListBoundingClientRect.left;

						if ((activeTabLeftOffset + activeTabBoundingClientRect.width) > tabListBoundingClientRect.width) {
							const currentLeftOffsetCSS = getComputedStyle($tabList.get(0)).getPropertyValue('--left');
							let currentLeftOffsetString = currentLeftOffsetCSS.replace('-', '');
							currentLeftOffsetString = currentLeftOffsetString.replace('px', '');
							const currentLeftOffset = parseFloat(currentLeftOffsetString);

							$tabList.get(0).style.setProperty('--left', `-${currentLeftOffset + activeTabBoundingClientRect.width}px`);
						} else if (activeTabBoundingClientRect.left < (tabListBoundingClientRect.left + 54)) {
							const currentLeftOffsetCSS = getComputedStyle($tabList.get(0)).getPropertyValue('--left');
							let currentLeftOffsetString = currentLeftOffsetCSS.replace('-', '');
							currentLeftOffsetString = currentLeftOffsetString.replace('px', '');
							const currentLeftOffset = parseFloat(currentLeftOffsetString);

							$tabList.get(0).style.setProperty('--left', `-${currentLeftOffset - activeTabBoundingClientRect.width - 54}px`);
						}
					});

				$('.tab__prev', $tabNavigation)
					.off('.prev')
					.on('click.prev', () => {
						const $tabPrev = $activeTab.prev();

						if ($tabPrev.exists()) {
							$('.ui-tabs-anchor', $tabPrev).trigger('click');
							$activeTab = $tabPrev;

							const activeTabBoundingClientRect = $activeTab.get(0).getBoundingClientRect();

							if ($activeTab.is(':first-of-type')) {
								$tabList.get(0).style.setProperty('--left', `0px`);
							} else if (activeTabBoundingClientRect.left < (tabListBoundingClientRect.left + 54)) {
								const currentLeftOffsetCSS = getComputedStyle($tabList.get(0)).getPropertyValue('--left');
								let currentLeftOffsetString = currentLeftOffsetCSS.replace('-', '');
								currentLeftOffsetString = currentLeftOffsetString.replace('px', '');
								const currentLeftOffset = parseFloat(currentLeftOffsetString);

								$tabList.get(0).style.setProperty('--left', `-${currentLeftOffset - activeTabBoundingClientRect.width - 54}px`);
							}
						}
					});

				$('.tab__next', $tabNavigation)
					.off('.next')
					.on('click.next', () => {
						const $tabNext = $activeTab.next();

						if ($tabNext.exists()) {
							$('.ui-tabs-anchor', $tabNext).trigger('click');
							$activeTab = $tabNext;

							const activeTabBoundingClientRect = $activeTab.get(0).getBoundingClientRect();
							const activeTabLeftOffset = activeTabBoundingClientRect.left - tabListBoundingClientRect.left;

							if ((activeTabLeftOffset + activeTabBoundingClientRect.width) > tabListBoundingClientRect.width) {
								const currentLeftOffsetCSS = getComputedStyle($tabList.get(0)).getPropertyValue('--left');
								let currentLeftOffsetString = currentLeftOffsetCSS.replace('-', '');
								currentLeftOffsetString = currentLeftOffsetString.replace('px', '');
								const currentLeftOffset = parseFloat(currentLeftOffsetString);

								$tabList.get(0).style.setProperty('--left', `-${currentLeftOffset + activeTabBoundingClientRect.width}px`);
							}
						}
					});
			}
		})
	},
	addTabScroll: function(tabContainer, scrollSpeed = 3, scrollDelay = 0) {
		const $tabContainer = $(tabContainer);
		const $tabLists = $('.dashlet-tabs', $tabContainer);

		$tabLists.each((listsIndex, tabList) => {
			const $tabList = $(tabList);
			let $tabNavigation = $('.tab__navigation', $tabList);
			const tabListBoundingClientRect = $tabList.get(0).getBoundingClientRect();

			if (!$tabNavigation.exists()) {
				if ($tabList.get(0).offsetWidth < $tabList.get(0).scrollWidth) {
					const $tabs = $('li', $tabList);
					let $activeTab = $('li.ui-state-active', $tabList);
					let prevInterval = undefined;
					let nextInterval = undefined;

					$tabList.addClass('dashlet-tabs--navigable');

					$tabList.prepend(`
						<div class="tab__navigation">
							<button class="tab__prev">
								<i class="fas fa-angle-left"></i>
							</button>
							<button class="tab__next">
								<i class="fas fa-angle-right"></i>
							</button>
						</div>
					`);

					$tabNavigation = $('.tab__navigation', $tabList);
					$tabList.css({
						'padding-left': $tabNavigation.width()
					});
					// reset previous data
					$tabList.get(0).style.removeProperty('--left');

					$('.tab__prev', $tabNavigation)
						.off('.prev')
						.on('mousedown.prev', () => {
							prevInterval = setInterval(() => {
								const currentLeftOffsetCSS = getComputedStyle($tabList.get(0)).getPropertyValue('--left');
								let currentLeftOffsetString = currentLeftOffsetCSS.replace('-', '');
								currentLeftOffsetString = currentLeftOffsetString.replace('px', '');
								const currentLeftOffset = parseFloat(currentLeftOffsetString);

								if (currentLeftOffset > 0) {
									$tabList.get(0).style.setProperty('--left', `-${currentLeftOffset - scrollSpeed}px`);
								}
							}, scrollDelay);
						})
						.on('mouseup.prev', () => {
							clearInterval(prevInterval);
						});

					$('.tab__next', $tabNavigation)
						.off('.next')
						.on('mousedown.next', () => {
							nextInterval = setInterval(() => {
								const currentLeftOffsetCSS = getComputedStyle($tabList.get(0)).getPropertyValue('--left');
								let currentLeftOffsetString = currentLeftOffsetCSS.replace('-', '');
								currentLeftOffsetString = currentLeftOffsetString.replace('px', '');
								const currentLeftOffset = parseFloat(currentLeftOffsetString);

								const lastTabBoundingClientRect = $('li:visible:last', $tabList).get(0).getBoundingClientRect();
								if (lastTabBoundingClientRect.right > (tabListBoundingClientRect.left + $tabList.width() + 54)) {
									$tabList.get(0).style.setProperty('--left', `-${currentLeftOffset + scrollSpeed}px`);
								}
							}, scrollDelay);
						})
						.on('mouseup.next', () => {
							clearInterval(nextInterval);
						});
				}
			} else {
				if ($tabList.get(0).offsetWidth >= $tabList.get(0).scrollWidth) {
					$tabNavigation = $('.tab__navigation', $tabList);

					$tabList.removeClass('dashlet-tabs--navigable');
					$tabList.css({
						'padding-left': 0
					});
					$tabNavigation.remove();
				}
			}
		})
	},
	toggleTab: function(tabId, tabPanelId, toggle) {
		if (!!toggle) {
			this.enableTab(tabId, tabPanelId);
		} else {
			this.disableTab(tabId, tabPanelId);
		}
	},
	enableTab: function(tabId, tabPanelId) {
		this.enableTabByIndex(tabId, this._getTabPanelIndex(tabId, tabPanelId));
	},
	enableTabByIndex: function(tabId, index) {
		$(this.__toSelectorId__(tabId)).tabs("enable", index);
	},
	disableTab: function(tabId, tabPanelId) {
		this.disableTabByIndex(tabId, this._getTabPanelIndex(tabId, tabPanelId));
	},
	disableTabByIndex: function(tabId, index) {
		$(this.__toSelectorId__(tabId)).tabs("disable", index);
	},
	showTab: function(tabPanelId, broadcastShownEvt) {
		tabPanelId = this.__toSelectorId__(tabPanelId);
		var $tabPane = $(tabPanelId);
		var $tab = $tabPane.closest('.dashlet-tab');
		if ($tabPane.exists() && $tab.exists()) {
			$tab.find('a[href="' + tabPanelId + '"]').closest("li").removeClass('ui-state-hidden');
			$tabPane.removeClass('ui-state-hidden');
			if (broadcastShownEvt) {
				$.broadcast($tabPane, 'tab-shown');
			}
		}
	},
	hideTab: function(tabPanelId, options) {
		let broadcastHiddenEvt = false;
		if (options === true) {
			broadcastHiddenEvt = true;
			options = {};
		} else {
			options = options || {};
			broadcastHiddenEvt = !!options.broadcastHiddenEvt;
		}
		tabPanelId = this.__toSelectorId__(tabPanelId);
		var $tabPane = $(tabPanelId);
		var $tab = $tabPane.closest('.dashlet-tab');
		if ($tabPane.exists() && $tab.exists()) {
			$tab.find('a[href="' + tabPanelId + '"]').closest("li").addClass('ui-state-hidden');
			if (!options.keepPaneVisible) {
				$tabPane.addClass('ui-state-hidden');
			}
			if (broadcastHiddenEvt) {
				$.broadcast($tabPane, 'tab-hidden');
			}
		}
	},
	activateTabStep: function(tabId, tabPanelId) {
		const $stepper = $('.stepper', tabId);
		let index = this._getTabPanelIndex(tabId, tabPanelId);
		const $step = this.getTabByIndex(tabId, index);
		const $nextSteps = $step.nextAll(':not(.step--outside)');

		if (index !== 0) {
			const $previousStep = this.getTabByIndex(tabId, index - 1);

			this.disableTabByIndex(tabId, index - 1);
			$previousStep.addClass("previous");
		}

		$step.removeClass('previous');
		$nextSteps.removeClass('previous');

		$nextSteps.each((_, step) => {
			const i = $(step).index();
			this.disableTabByIndex(tabId, i);
		});

		this.enableTabByIndex(tabId, index);
		this.activateTabByIndex(tabId, index);
	},
	activateBackwardTabStep: function(tabId, tabPanelId) {
		const $stepper = $('.stepper', tabId);
		let index = this._getTabPanelIndex(tabId, tabPanelId);
		const $oldStep = this.getTabByIndex(tabId, index + 1);

		this.enableTabByIndex(tabId, index);
		this.activateTabByIndex(tabId, index);
		this.disableTabByIndex(tabId, index + 1);
		this.getTabById(tabPanelId).removeClass("previous");
	},
	hideStepper: function(tabManagerId) {
		const $tabManagerId = $(tabManagerId);
		const $stepper = $('.stepper', $tabManagerId);

		$stepper.hide();
	},
	showStepper: function(tabManagerId) {
		const $tabManagerId = $(tabManagerId);
		const $stepper = $('.stepper', $tabManagerId);

		$stepper.show();
	},
	hideInsideTabSteps: function(tabManagerId) {
		const $tabManagerId = $(tabManagerId);
		const $stepper = $('.stepper', $tabManagerId);
		const $steps = $('.step:not(.step--outside)', $stepper);

		$steps.hide();
	},
	showInsideTabSteps: function(tabManagerId) {
		const $tabManagerId = $(tabManagerId);
		const $stepper = $('.stepper', $tabManagerId);
		const $steps = $('.step:not(.step--outside)', $stepper);

		$steps.show();
	},
	hideOutsideTabSteps: function(tabManagerId) {
		const $tabManagerId = $(tabManagerId);
		const $stepper = $('.stepper', $tabManagerId);
		const $steps = $('.step--outside', $stepper);

		$steps.hide();
	},
	showOutsideTabSteps: function(tabManagerId) {
		const $tabManagerId = $(tabManagerId);
		const $stepper = $('.stepper', $tabManagerId);
		const $steps = $('.step--outside', $stepper);

		$steps.show();
	},
	activateTab: function(tabId, tabPanelId) {
		var $tab;
		if (arguments.length == 1) {
			tabPanelId = tabId;
			$tab = $(this.__toSelectorId__(tabPanelId)).closest('.dashlet-tab');
			tabId = $tab.attr('id');
		} else {
			$tab = $(this.__toSelectorId__(tabId));
		}
		var index = this._getTabPanelIndex(tabId, tabPanelId);
		/* 'ui-state-focus' should be removed otherwise tab l&f is not correctly aligned */
		$tab.find("li.ui-state-focus").removeClass('ui-state-focus');
		$tab.tabs('option', 'active', index);
	},
	activateTabByIndex: function(tabId, index) {
		var $tab = $(this.__toSelectorId__(tabId));

		$tab.find("li.ui-state-focus").removeClass('ui-state-focus');
		$tab.tabs('option', 'active', index);
	},
	getActiveTabPanel: function(tabId) {
		var activeIndex = $(this.__toSelectorId__(tabId)).tabs('option', 'active');
		return this.getTabPanelByIndex(tabId, activeIndex);
	},
	getActiveTabPanelId: function(tabId) {
		var activeIndex = $(this.__toSelectorId__(tabId)).tabs('option', 'active');
		return this.getTabIdByIndex(tabId, activeIndex);
	},
	getTabPanelById: function(tabId, tabPanelId) {
		var activeIndex = this._getTabPanelIndex(tabId, tabPanelId);
		return this.getTabPanelByIndex(tabId, activeIndex);
	},
	getTabByIndex: function(tabId, index) {
		const tabContainerSelector = this.__toSelectorId__(tabId);
		const tab = $('.dashlet-tabs li', tabContainerSelector).get(index);
		return $(tab);
	},
	getTabPanelByIndex: function(tabId, activeIndex) {
		var panel = $(this.__toSelectorId__(tabId)).find('.ui-tabs-panel')[activeIndex];
		return $(panel);
	},
	getTabIdByIndex: function(tabId, activeIndex) {
		var panel = $(this.__toSelectorId__(tabId)).find('.ui-tabs-panel')[activeIndex];
		return $(panel).attr('id');
	},
	getNavTabById: function(tabId) {
		var tabSelector = this.__toSelectorId__(tabId);
		var $tabs = $(tabSelector).closest('.ui-tabs');
		return $('a[href="' + tabSelector + '"]', $tabs);
	},
	getTabById: function(tabId) {
		var tabSelector = this.__toSelectorId__(tabId);
		var $tabs = $(tabSelector).closest('.ui-tabs');
		return $('a[href="' + tabSelector + '"]', $tabs).closest('li');
	},
	isTabActive: function(tabId) {
		var tabSelector = this.__toSelectorId__(tabId);
		return $(tabSelector).is(':visible');
	},
	_getTabPanelIndex: function(tabId, tabPanelId) {
		tabId = this.__toSelectorId__(tabId);
		tabPanelId = this.__toSelectorId__(tabPanelId);
		let li = $(tabId + ' a[href="' + tabPanelId + '"]').closest('li');
		let ul = li.closest('ul');
		let hasTabNav = ul.find('.tab__navigation').exists();
		var index = li.index() - (hasTabNav ? 1 : 0); // if tabnav is present, the index must be decremented by 1
		return index;
	},
	__toSelectorId__: function(id) {
		return (id.indexOf('#') == 0) ? id : ('#' + id);
	},
	/* for old style providers, without 'method' */
	invokeSimpleProvider: function(provider, input, options) {
		var data = $.extend({}, {
			impl: provider,
		}, input || {});
		var prv = provider.substring(provider.lastIndexOf('.') + 1);
		var settings = $.extend({}, {
			url: hrd.globals.jsondataURI + '?_=' + prv,
			headers: {},
			dataType: "json",
			data: data
		}, options || {});
		if (hrd.globals.apiKey != undefined) {
			settings.headers["Api-Key"] = hrd.globals.apiKey;
		}
		if (hrd.globals.apiKeyExt != undefined) {
			settings.headers["Api-Key-Ext"] = hrd.globals.apiKeyExt;
		}
		if (hrd.globals.apiKeyUser != undefined) {
			settings.headers["Api-Key-User"] = hrd.globals.apiKeyUser;
		}
		return $.ajax(settings).then(function(response, status, xhr) {
			return $.when(response);
		});
	},
	invokeProvider: function(provider, method, input, options) {
		options = options || {}
		let data = $.extend({}, {
			impl: provider,
			method: method
		}, input || {});
		let prv = provider.substring(provider.lastIndexOf('.') + 1) + '.' + method;
		if(options.uriInfo) {
			prv = `${options.uriInfo}.${prv}`;
		}
		let settings = $.extend({}, {
			url: `${hrd.globals.jsondataURI}?_=${prv}`,
			headers: {},
			dataType: 'json',
			data: data
		}, options || {});
		if (hrd.globals.apiKey != undefined) {
			settings.headers["Api-Key"] = hrd.globals.apiKey;
		}
		if (hrd.globals.apiKeyExt != undefined) {
			settings.headers["Api-Key-Ext"] = hrd.globals.apiKeyExt;
		}
		if (hrd.globals.apiKeyUser != undefined) {
			settings.headers["Api-Key-User"] = hrd.globals.apiKeyUser;
		}
		return $.ajax(settings).then((response, status, xhr) => $.when(response));
	},
	invokeDataTable: function(sProvider, extraArgs, extraSettings) {
		var prv = sProvider ? sProvider.substring(sProvider.lastIndexOf('.') + 1) : undefined;
		var deferred = $.Deferred();
		extraArgs = extraArgs || {};
		extraSettings = extraSettings || {};
		var data = $.extend({}, extraArgs, {
			sProvider: sProvider,
			iPageSize: -1, // valore 0 o negativo implica richiedere TUTTI i records
			iDisplayStart: 0
		});
		let settings = {
			url: hrd.globals.datatableURI + (prv ? '?_=' + prv : ''),
			headers: {},
			dataType: 'json',
			data: data
		};
		settings = $.extend(settings, extraSettings);
		if (hrd.globals.apiKey != undefined) {
			settings.headers["Api-Key"] = hrd.globals.apiKey;
		}
		if (hrd.globals.apiKeyExt != undefined) {
			settings.headers["Api-Key-Ext"] = hrd.globals.apiKeyExt;
		}
		if (hrd.globals.apiKeyUser != undefined) {
			settings.headers["Api-Key-User"] = hrd.globals.apiKeyUser;
		}
		$.ajax(settings)
			.then((data) => deferred.resolve(data))
			.fail((jqXHR, textStatus, errorThrown) => deferred.reject(textStatus))
			;
		return deferred.promise();
	},
	invokeActionURI: function(url, input, dataType) {
		dataType = dataType || 'json';
		var deferred = $.Deferred();
		$.ajax({
			url: hrd.fn.actionURI(url),
			dataType: dataType,
			data: input || {}
		})
			.then(function(response, textStatus, jqXHR) {
				deferred.resolve(response);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				deferred.reject(errorThrown);
			});
		return deferred.promise();
	},
	invokeRest: function(path, input, method, dataType) {
		path = path || '';
		method = method || 'GET'
		dataType = dataType || 'json';
		var deferred = $.Deferred();
		$.ajax({
			url: hrd.globals.restURI + path,
			dataType: dataType,
			type: method,
			data: input || {}
		})
			.then(function(response, textStatus, jqXHR) {
				deferred.resolve(response);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				deferred.reject(errorThrown);
			});
		return deferred.promise();
	},
	invokeSnippet: function(path, dataType) {
		path = path || '';
		dataType = dataType || 'html';
		var method = method || 'GET'
		var deferred = $.Deferred();
		$.ajax({
			url: hrd.globals.contextRoot + '/media/js/dashboard/' + path,
			dataType: dataType,
			type: method,
			data: { version: hrd.globals.version }
		})
			.then(function(response, textStatus, jqXHR) {
				deferred.resolve(response);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				deferred.reject(errorThrown);
			});
		return deferred.promise();
	},
	/**
	 * Useful for invoking a method of a different dashlet,
	 * can be overridden by some dashboard instances in order to mask dashlet name to caller
	 */
	invokeMethod: function(dashletInstance, sMethod) {
		let params = Array.prototype.slice.call(arguments, 0);
		return this._internalInvokeMethod_.apply(this, params);
	},
	/**
	 * Useful for invoking a method of a different dashlet,
	 * can be overridden by some dashboard instances in order to mask dashlet name to caller
	 */
	_internalInvokeMethod_: function(dashletInstance, sMethod) {
		if (dashletInstance && typeof dashletInstance[sMethod] === 'function') {
			return dashletInstance[sMethod].apply(dashletInstance, Array.prototype.slice.call(arguments, 2));
		} else {
			console.log(`"invokeMethod": method "${sMethod}" not available for dashlet "${dashletInstance ? dashletInstance._FULL_ : ""}"`);
		}
	},
	applyDoubleSize: function() {
		$('body').attr('data-dashboard-size', '2x');
	},
	isDoubleSize: function() {
		return $('body').data('dashboard-size') == '2x';
	},
	showStatusMessages: function(options) {
		var statusMessageManager = new hrd.manager.StatusMessageManager();
		return statusMessageManager.show(options);
	},
	/***
	 * Specific iframe dialog for reports in PDF mode
	 */
	showReport: function(params, options) {
		let pdfViewerMode = this.toolbox.get('globals.prefs.tenant.layout.pdfViewerMode', hrd, 'embedded');
		params = params || {};
		// call to ReportFormBasicAction.create in order to reset session
		let input4Create = {
			printAction: params.printAction,
			direct: true
		};
		if(params.htmlFragment != undefined) {
			input4Create.htmlFragment = params.htmlFragment;
			delete params.htmlFragment;
		}
		if(params.versionName != undefined) {
			input4Create.versionName = params.versionName;
			delete params.versionName;
		}
		if(params.forceUseSession != undefined) {
			input4Create.forceUseSession = params.forceUseSession;
			delete params.forceUseSession;
		}
		return this.invokeActionURI('json.go.reporting.reportFormBasic.create', input4Create).then(() => {
			let defaultParams = {
				type: 'pdf',
				i18nPrefix: 'go.reports'
			};
			let defaultOptions = {
				remoteCallbackInvocation: false
			};
			params = $.extend({}, defaultParams, params);
			options = $.extend({}, defaultOptions, options);
			let exportType = params.type
			let uri = (exportType === 'pdf' && pdfViewerMode === 'embedded') ? 'go.reporting.reportFormBasic.print.wizard.store' : 'go.reporting.reportFormBasic.print.wizard';
			
			if(exportType !== 'pdf') {
				options.modal = false; // not need modal for downloading
			}
			let promise = hrd.dashboard.showIFrameDialog(uri, params, options);

			if(exportType !== 'pdf') {
				/* make the iframe invisible */
				$('#dashboard-iframe-dialog').closest('.ui-dialog').css('visibility', 'hidden');
				
				let delay = options.delayBeforeClose || 2000;
		
				/* wait "N" seconds and then show again dialog and close it */
				$.timeout(delay).then(() => {
					$('#dashboard-iframe-dialog').closest('.ui-dialog').css('visibility', 'visible');
					hrd.dashboard.closeCurrentIFrameDialog();
				});
			}
			return promise
		});
	},
	/***
	 * Specific iframe dialog for reports in PDF mode
	 * 
	 * 	@param pdfViewerOptions: accepted values
	 * 
	 * 	- zoom: zoom level. Example: zoom:200 (accepted formats: [zoom],[left offset],[top offset], page-width, page-height, page-fit, auto)
	 *  - page: page number. Example: page:2
	 *  - pagemode: sidebar state. Example: pagemode:'none' (accepted values: none, thumbs, bookmarks, attachments)
	 */
	showRemotePDF: function(remoteUrl, urlParams, dialogOptions, pdfViewerOptions) {
		urlParams = urlParams || {};
		let defaultOptions = {
			dialogClass: 'pdf-viewer',
			title: 'Title',
			actionURI: false,
			remoteCallbackInvocation: false
		};
		let defaultViewerOptions = {
			page: 1,
			zoom: 'page-width',
			pagemode: 'none'
		};
		let qs = $.hrd.serialize(urlParams);
		dialogOptions = $.extend({}, defaultOptions, dialogOptions);
		pdfViewerOptions = $.extend({}, defaultViewerOptions, pdfViewerOptions);
		let specs = $.extend({}, { remoteUrl: remoteUrl, qs: qs }, pdfViewerOptions);
		return hrd.dashboard.showIFrameDialog(`${hrd.globals.contextRoot}/content/pdf/PdfViewer.jsp`, specs, dialogOptions);
	}
});
